import React from "react";
import { useCompare } from "../context/CompareContext";
import "./CompareToggle.css";

// Sits inside a product card's already-flex top row (partNo on the left,
// this on the right) or standalone on the detail page. Stops the click from
// bubbling to the card's own onClick (which navigates to the product page).
const CompareToggle = ({ product }) => {
  const { isInCompare, toggleCompare } = useCompare();
  const checked = isInCompare(product.id);

  return (
    <label
      className={`compare-toggle ${checked ? "compare-toggle--checked" : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={() => toggleCompare(product)}
      />
      Compare
    </label>
  );
};

export default CompareToggle;
